import dayjs from "dayjs";
import type { SummaryRecord } from "../types/analyzer";
import { getScoreColor } from "../utils/scores";

interface HistoricalDataProps {
	history: SummaryRecord[];
}

const orderedCategories: Array<keyof SummaryRecord["scores"]> = [
	"performance",
	"accessibility",
	"bestPractices",
	"seo",
	"pwa",
];

const categoryLabels: Record<keyof SummaryRecord["scores"], string> = {
	performance: "Performance",
	accessibility: "Accesibilidad",
	bestPractices: "Best Practices",
	seo: "SEO",
	pwa: "PWA",
};

function HistoricalData({ history }: HistoricalDataProps) {
	if (!history.length) {
		return (
			<div className="history-panel">
				<p className="history-panel__empty">
					Aún no hay ejecuciones previas. Corre tu primera auditoría para construir la línea de tiempo.
				</p>
			</div>
		);
	}

	return (
		<div className="history-panel">
			<table className="history-table">
				<thead>
					<tr>
						<th scope="col">#</th>
						<th scope="col">Fecha</th>
						<th scope="col">Sitio</th>
						{orderedCategories.map((key) => (
							<th scope="col" key={key}>
								{categoryLabels[key]}
							</th>
						))}
					</tr>
				</thead>
				<tbody>
					{history.map((item, index) => (
						<tr key={item.timestamp}>
							<td>{index + 1}</td>
							<td>{dayjs(item.timestamp).format("DD MMM YYYY")}</td>
							<td>{item.web ? item.web.toLowerCase() : "Sin URL"}</td>
							{orderedCategories.map((scoreKey) => (
								<td
									key={scoreKey}
									style={{
										color: getScoreColor(item.scores[scoreKey]),
									}}
								>
									{item.scores[scoreKey]
										? (item.scores[scoreKey] * 100).toFixed(0)
										: "—"}
								</td>
							))}
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
}

export default HistoricalData;
